
import L from "leaflet"
import "leaflet.markercluster"

(L as any).MarkerClusterGroupNoAnimation = L.MarkerClusterGroup.extend({
  _animationStart(){
    // do nothing
  },
  _animationZoomIn(previousZoomLevel: number, newZoomLevel: number){
    this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, previousZoomLevel)
    this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds())
  },
  _animationZoomOut(previousZoomLevel: number, newZoomLevel: number){
    this._topClusterLevel._recursivelyRemoveChildrenFromMap(this._currentShownBounds, previousZoomLevel)
    this._topClusterLevel._recursivelyAddChildrenToMap(null, newZoomLevel, this._getExpandedVisibleBounds())
  },
  _animationAddLayer(layer: L.Layer, newCluster: L.MarkerCluster){
    return this._animationAddLayerNonAnimated(layer, newCluster)
  },
});

(L as any).markerClusterGroupNoAnimation = (options: object) => new (L as any).MarkerClusterGroupNoAnimation(options)
